import ServiceRepository from "./repositories/service";
import SettingsRepository from "./repositories/settings";

const repositories = {
    services: ServiceRepository,
    settings: SettingsRepository,
};

export const RepositoryFactory = {
    get: name => repositories[name]
};